import { Acupuncture } from './acupuncture'
import { Agents } from './agents'
import { Allergies } from './allergies'
import { Ambulance } from './ambulance'
import { Anesthesia } from './anesthesia'
import { Baby } from './baby'
import { Bandaid } from './bandaid'
import { Bed } from './bed'
import { Book } from './book'
import { Brain } from './brain'
import { Cancer } from './cancer'
import { CareSearch } from './care-search'
import { Carrot } from './carrot'
import { Coverage } from './coverage'
import { CreditCard } from './credit-card'
import { Crutches } from './crutches'
import { Dermatology } from './dermatology'
import { Drip } from './drip'
import { Ear } from './ear'
import { Email } from './email'
import { Endocrinologist } from './endocrinologist'
import { Female } from './female'
import { Flash } from './flash'
import { Foot } from './foot'
import { Genetics } from './genetics'
import { Geriatrics } from './geriatrics'
import { Gift } from './gift'
import { Head } from './head'
import { Health } from './health'
import { Hematologist } from './hematologist'
import { Holistic } from './holistic'
import { Hospital } from './hospital'
import { IdCard } from './id-card'
import { Imaging } from './imaging'
import { Immunologist } from './immunologist'
import { InfectiousDisease } from './infectious-disease'
import { Joint } from './joint'
import { Kidneys } from './kidneys'
import { Lab } from './lab'
import { Liver } from './liver'
import { Lock } from './lock'
import { Lungs } from './lungs'
import { Massage } from './massage'
import { Medkit } from './medkit'
import { Money } from './money'
import { Music } from './music'
import { Needle } from './needle'
import { Neurosurgeon } from './neurosurgeon'
import { Nose } from './nose'
import { Nurse } from './nurse'
import { OccupationalTherapy } from './occupational-therapy'
import { Office } from './office'
import { Orthodontist } from './orthodontist'
import { Pediatrician } from './pediatrician'
import { Pencil } from './pencil'
import { Phone } from './phone'
import { Photos } from './photos'
import { PhysicalTherapist } from './physical-therapist'
import { PlasticSurgeon } from './plastic-surgeon'
import { Pregnancy } from './pregnancy'
import { Pills } from './pills'
import { Prosthetic } from './prosthetic'
import { Question } from './question'
import { Receipt } from './receipt'
import { Religion } from './religion'
import { Research } from './research'
import { Run } from './run'
import { Search } from './search'
import { Settings } from './settings'
import { Sidecar } from './sidecar'
import { Sleep } from './sleep'
import { Speech } from './speech'
import { Spine } from './spine'
import { Stethoscope } from './stethoscope'
import { Stomach } from './stomach'
import { Surgery } from './surgery'
import { Telehealth } from './telehealth'
import { Thermometer } from './thermometer'
import { Tooth } from './tooth'
import { UrgentCare } from './urgent-care'
import { Urologist } from './urologist'
import { Vascular } from './vascular'
import { Vision } from './vision'

const careIcons: { [key: string]: any } = {
  acupuncture: Acupuncture,
  agents: Agents,
  allergies: Allergies,
  ambulance: Ambulance,
  anesthesia: Anesthesia,
  baby: Baby,
  bandaid: Bandaid,
  bed: Bed,
  book: Book,
  brain: Brain,
  cancer: Cancer,
  careSearch: CareSearch,
  carrot: Carrot,
  coverage: Coverage,
  creditCard: CreditCard,
  crutches: Crutches,
  dermatology: Dermatology,
  drip: Drip,
  ear: Ear,
  email: Email,
  endocrinologist: Endocrinologist,
  female: Female,
  flash: Flash,
  foot: Foot,
  genetics: Genetics,
  geriatrics: Geriatrics,
  gift: Gift,
  head: Head,
  health: Health,
  hematologist: Hematologist,
  holistic: Holistic,
  hospital: Hospital,
  idCard: IdCard,
  imaging: Imaging,
  immunologist: Immunologist,
  infectiousDisease: InfectiousDisease,
  joint: Joint,
  kidneys: Kidneys,
  lab: Lab,
  liver: Liver,
  lock: Lock,
  lungs: Lungs,
  massage: Massage,
  medkit: Medkit,
  money: Money,
  music: Music,
  needle: Needle,
  neurosurgeon: Neurosurgeon,
  nose: Nose,
  nurse: Nurse,
  occupationalTherapy: OccupationalTherapy,
  office: Office,
  orthodontist: Orthodontist,
  pediatrician: Pediatrician,
  pencil: Pencil,
  phone: Phone,
  photos: Photos,
  physicalTherapist: PhysicalTherapist,
  plasticSurgeon: PlasticSurgeon,
  pregnancy: Pregnancy,
  pills: Pills,
  prosthetic: Prosthetic,
  question: Question,
  receipt: Receipt,
  religion: Religion,
  research: Research,
  run: Run,
  search: Search,
  settings: Settings,
  sidecar: Sidecar,
  sleep: Sleep,
  speech: Speech,
  spine: Spine,
  stethoscope: Stethoscope,
  stomach: Stomach,
  surgery: Surgery,
  telehealth: Telehealth,
  thermometer: Thermometer,
  tooth: Tooth,
  urgentCare: UrgentCare,
  urologist: Urologist,
  vascular: Vascular,
  vision: Vision,
}

export default careIcons
